import React from 'react';

// FIXME little fixes children number etc ...

export const BaseLabel = props => {
  const {
    children,
    classNames,
    formatLabel,
    type
  } = props;
  const labelValue = formatLabel ? formatLabel(children, type) : children;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames[`${props.type}Label`]
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames.labelContainer
  }, labelValue));
};